import type { IconNode } from '../types';

/**
 * @name face-angry
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTUgMTJ2LTEuNTg0IiAvPgogIDxwYXRoIGQ9Ik0xNyAxMGE1IDUgMCAwMC0zIDEiIC8+CiAgPHBhdGggZD0iTTcgMTBhNSA1IDAgMDEzIDEiIC8+CiAgPHBhdGggZD0iTTkgMTJ2LTEuNTg0IiAvPgogIDxwYXRoIGQ9Ik05IDE3YTUgNSAwIDAxNi4wMDEgMCIgLz4KICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/face-angry
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const FaceAngry: IconNode = [
  ['path', { d: 'M15 12v-1.584' }],
  ['path', { d: 'M17 10a5 5 0 00-3 1' }],
  ['path', { d: 'M7 10a5 5 0 013 1' }],
  ['path', { d: 'M9 12v-1.584' }],
  ['path', { d: 'M9 17a5 5 0 016.001 0' }],
  ['circle', { cx: '12', cy: '12', r: '10' }],
];

export default FaceAngry;
